if (!customElements.get('purchase-slide-card')) {
  customElements.define('purchase-slide-card', class PurchaseSlideCard extends HTMLElement {
    constructor() {
      super();
      this.targetFrame = null;
      this.renderFrame = null;
      this.currentSecondCardOffset = 100;
      this.targetSecondCardOffset = 100;
      this.hasRendered = false;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.updateTarget = this.updateTarget.bind(this);
      this.renderInertia = this.renderInertia.bind(this);
    }

    connectedCallback() {
      this.section = this.closest('.purchase-slide-card');
      this.sticky = this.querySelector('.purchase-slide-card__sticky');
      this.cards = this.querySelectorAll('.purchase-slide-card__card');

      if (!this.section || !this.sticky) {
        return;
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.section.classList.add('is-reduced-motion');
        return;
      }

      if (this.cards.length < 2) {
        this.section.style.setProperty('--purchase-slide-card-second-x', '0%');
        return;
      }

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      this.updateTarget(true);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);

      if (this.targetFrame) {
        window.cancelAnimationFrame(this.targetFrame);
        this.targetFrame = null;
      }

      if (this.renderFrame) {
        window.cancelAnimationFrame(this.renderFrame);
        this.renderFrame = null;
      }
    }

    handleScroll() {
      this.requestUpdate();
    }

    handleResize() {
      this.requestUpdate();
    }

    requestUpdate() {
      if (this.targetFrame) {
        return;
      }

      this.targetFrame = window.requestAnimationFrame(this.updateTarget);
    }

    updateTarget(shouldSnap = false) {
      this.targetFrame = null;

      const scrollDistance = Math.max(this.section.offsetHeight - this.sticky.offsetHeight, 1);
      const sectionTop = this.section.getBoundingClientRect().top;
      const progress = Math.min(Math.max(-sectionTop / scrollDistance, 0), 1);
      this.targetSecondCardOffset = (1 - progress) * 100;

      if (shouldSnap === true || !this.hasRendered) {
        this.currentSecondCardOffset = this.targetSecondCardOffset;
        this.hasRendered = true;
        this.section.style.setProperty('--purchase-slide-card-second-x', `${this.currentSecondCardOffset}%`);
        return;
      }

      this.requestRender();
    }

    requestRender() {
      if (this.renderFrame) {
        return;
      }

      this.renderFrame = window.requestAnimationFrame(this.renderInertia);
    }

    renderInertia() {
      this.renderFrame = null;

      const distance = this.targetSecondCardOffset - this.currentSecondCardOffset;
      this.currentSecondCardOffset += distance * 0.18;

      if (Math.abs(distance) < 0.08) {
        this.currentSecondCardOffset = this.targetSecondCardOffset;
      }

      this.section.style.setProperty('--purchase-slide-card-second-x', `${this.currentSecondCardOffset}%`);

      if (this.currentSecondCardOffset !== this.targetSecondCardOffset) {
        this.requestRender();
      }
    }
  });
}